export const TYPES = [
  { label: "electronic_fences.map_option_circle", value: 1 },
  { label: "electronic_fences.map_option_polygonal", value: 2 },
  { label: "electronic_fences.map_option_route", value: 3 },
];
